// @ts-check

/** @file Shared declarative pull policy for project-domain local models. */

/** @import {ModelSyncDeclarationConfig, SyncClientConflictTrackingConfig} from "velocious/build/src/sync/sync-client-types.js" */

/**
 * Drops server-only authorization routing facts before assigning a feed row.
 * @param {{data: Record<string, unknown>}} args Sync apply arguments.
 * @returns {Record<string, unknown>} Local model attributes.
 */
export function projectReplicaSyncAttributes({data}) {
  const {syncScope: _syncScope, ...attributes} = data
  return attributes
}

/**
 * Builds the pull policy plus the current replica's durable conflict queue.
 * Automatic write tracking stays disabled until the downstream offline-write
 * work moves domain mutations onto the replica.
 * @param {{conflictTracking?: SyncClientConflictTrackingConfig}} [options] Client-local conflict ownership.
 * @returns {ModelSyncDeclarationConfig} Replica-specific sync declaration.
 */
export function projectReplicaSyncDeclaration({conflictTracking} = {}) {
  return Object.freeze({
    attributes: projectReplicaSyncAttributes,
    ...(conflictTracking ? {conflictTracking} : {}),
    syncType: "upsert",
    track: false
  })
}

/** Static pull-only declaration used before a replica-specific client is created. */
export const PROJECT_REPLICA_SYNC_DECLARATION = projectReplicaSyncDeclaration()
